<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="手机号" prop="mobile">
            <el-input size="small" style="width: 200px;" v-model="formInline.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>

          <el-form-item label="用户昵称" prop="nickName">
            <el-input size="small" style="width: 200px;" v-model="formInline.nickName" placeholder="请输入用户昵称"></el-input>
          </el-form-item>


          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
            <el-button size="small" type="primary" icon="el-icon-download" @click="importExcelItem()">导出数据</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="id" label="ID" align="center"></el-table-column>
          <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
          <el-table-column prop="nickName" label="用户昵称" align="center"></el-table-column>
          <el-table-column align="center"  prop="isSms" label="是否接收短信" width="170px" >
            <template slot-scope="scope">
              <el-switch
                  v-model="scope.row.isSms"
                  active-text="接收"
                  inactive-text="不接收"
                  :active-value="1"
                  :inactive-value="0"
                  @change="turn(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="avatar" label="头像" align="center" >
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover">
                <a :href="scope.row.avatar" target="_blank" title="查看最大化图片"><img :src="scope.row.avatar" style="width: 300px;height: 300px" /></a>
                <img slot="reference" :src="scope.row.avatar" style="width: 100px;height: 100px; cursor:pointer" />
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column align="center"  prop="createTime" label="登录时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>









      </el-main>
    </el-container>
  </div>
</template>

<script>


import {qryUserList,upUser} from '../../api/userApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import {downloadWxMember} from "../../api/couApi";


export default {
  name: "userList",
  data() {
    return {
      title:'修改',
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        mobile:'',
        nickName:'',
        page:1,
        pageSize:10
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      qryUserList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })

    },

    resetFrom(){
      this.formInline.mobile = '';
      this.formInline.nickName = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },

    importExcelItem(){
      downloadWxMember(this.formInline).then(res=>{
        let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        // type值看后台格式,有可能是application/x-xls或application/vnd.ms-excel
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        //配置下载的文件名
        link.download = timestampToTime(new Date())+'导出用户列表.xls'
        link.click()
      });
    },
    turn(row) {
      upUser(row).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },


  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/user.vue